// front/plugins/gtag.client.js
export default ({ app }) => {
  app.router.afterEach((to) => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-H3QSY1ZC7E', {
        page_path: to.fullPath,
      });
    }
  });
};
